import { BlockWrapper } from "../Preview";
import { Popover } from "@headlessui/react";
import React from "react";
import { generateCss, generateEvent, generateStyle } from "../../functions/sortableFunctions";
const PopoverComponent = ({ block, ...props }: any) => {

    return (
        <Popover
            {...block.data}
            id={block.id}
            className={generateCss({
                props: {
                    ...props,
                    block: block
                },
            })}
            as={block.data?.type ? block.data.type : 'div'}
            style={generateStyle({
                props: {
                    ...props,
                    block
                }
            })}
            onClick={block.events?.onClick ? async (e: any) => {
                await generateEvent({
                    props: {
                        ...props,
                        block: block
                    },
                    e: e,
                    event: "onClick"
                });
            } : null}
            onDoubleClick={block.events?.onDoubleClick ? async (e: any) => {
                await generateEvent({
                    props: {
                        ...props,
                        block: block
                    },
                    e: e,
                    event: "onDoubleClick"
                });
            } : null}
            onContextMenu={block.events?.onContextMenu ? async (e: any) => {
                await generateEvent({
                    props: {
                        ...props,
                        block: block
                    },
                    e: e,
                    event: "onContextMenu"
                });
            } : null}
            onMouseOver={block.events?.onMouseOver ? async (e: any) => {
                await generateEvent({
                    props: {
                        ...props,
                        block: block
                    },
                    e: e,
                    event: "onMouseOver"
                });
            } : null}
            onMouseLeave={block.events?.onMouseLeave ? async (e: any) => {
                await generateEvent({
                    props: {
                        ...props,
                        block: block
                    },
                    e: e,
                    event: "onMouseLeave"
                });
            } : null}
        >
            {
                ({ open, close }: any) => {
                    return (
                        block.children.map((value: any, index: any) => {
                            return <BlockWrapper
                                {...props}
                                key={index}
                                block={value}
                                open={open}
                                close={close}
                            />
                        })
                    )
                }
            }
        </Popover>
    )
}
export default PopoverComponent;